// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"036ce236","732":"b11cf18b","977":"27345bf3"}[chunkId] + ".chunk.js";
};